const DefaultSliderData = {
  arrows: true,
  autoplay: false,
  dots: true,
  id: 1,
  mapper_order: "",
  mappers: [],
  name: "",
  speed: "5000"
}

export default DefaultSliderData
